import { Paragraph2, UIHeading2 } from '@cian/ui-kit';
import React, { memo } from 'react';

import styles from './CommercialPriceLines.css';
import { ContentRow } from '../../ContentRow';
import { GeneralInfoSectionRow } from '../../GeneralInfoSectionRow';

interface ICommercialPriceLinesProps {
  priceMain: string;
  priceSub?: string;
}

export const CommercialPriceLinesComponent: React.FC<ICommercialPriceLinesProps> = ({ priceMain, priceSub }) => {
  return (
    <GeneralInfoSectionRow>
      <div className={styles['wrapper']} data-name="CommercialPriceLinesComponent">
        <ContentRow>
          <UIHeading2 data-mark="CommercialPriceMain" color="text-primary-default">
            {priceMain}
          </UIHeading2>
        </ContentRow>
        {priceSub && (
          <ContentRow>
            <Paragraph2 data-mark="CommercialPriceSub" color="text-secondary-default">
              {priceSub}
            </Paragraph2>
          </ContentRow>
        )}
      </div>
    </GeneralInfoSectionRow>
  );
};

CommercialPriceLinesComponent.displayName = 'CommercialPriceLines';

export const CommercialPriceLines = memo(CommercialPriceLinesComponent);
